export function IconLayers() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
      <path d="M12 3.5 3 8l9 4.5 9-4.5-9-4.5Z" stroke="#1670ea" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M3 12.5l9 4.5 9-4.5" stroke="#1670ea" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 16.5l9 4.5 9-4.5" stroke="#1670ea" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconBars() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
      <rect x="4" y="13" width="3.4" height="7" rx="1" fill="#1670ea" />
      <rect x="10.3" y="8" width="3.4" height="12" rx="1" fill="#1670ea" />
      <rect x="16.6" y="4" width="3.4" height="16" rx="1" fill="#1670ea" />
    </svg>
  );
}

export function IconSparkle() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 2.5c.6 3.6 1.6 5.3 3.5 6.5 1.6 1 3.2 1.2 6 1.5-2.8.3-4.4.5-6 1.5-1.9 1.2-2.9 2.9-3.5 6.5-.6-3.6-1.6-5.3-3.5-6.5-1.6-1-3.2-1.2-6-1.5 2.8-.3 4.4-.5 6-1.5 1.9-1.2 2.9-2.9 3.5-6.5Z"
        fill="#1670ea"
      />
    </svg>
  );
}

export function IconOrbit() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="8.5" stroke="#1670ea" strokeWidth="1.6" />
      <circle cx="12" cy="12" r="3" fill="#1670ea" />
      <circle cx="20.5" cy="12" r="1.4" fill="#1670ea" />
    </svg>
  );
}

export function IconLeaf() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M5 19c8 0 14-6 14-14 0 0-13-1-14 9-.4 3 0 5 0 5Z"
        stroke="#1670ea"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path d="M5 19c2-4 5-7 9-9" stroke="#1670ea" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

export function IconUsers() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle cx="9" cy="8" r="3" stroke="#1670ea" strokeWidth="1.6" />
      <path d="M3 20c0-3.6 2.7-6 6-6s6 2.4 6 6" stroke="#1670ea" strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="17" cy="8.5" r="2.3" stroke="#1670ea" strokeWidth="1.4" />
      <path d="M15.5 14.3c2.7.4 4.5 2.5 4.5 5.7" stroke="#1670ea" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  );
}

export function IconChart() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect x="4" y="12" width="3" height="8" rx="0.8" fill="#1670ea" />
      <rect x="10.5" y="7" width="3" height="13" rx="0.8" fill="#1670ea" />
      <rect x="17" y="3" width="3" height="17" rx="0.8" fill="#1670ea" />
    </svg>
  );
}

export function IconShield() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 3 4.5 5.6v5.8c0 5 3.2 8.3 7.5 9.6 4.3-1.3 7.5-4.6 7.5-9.6V5.6L12 3Z"
        stroke="#1670ea"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path d="M8.7 12.2l2.2 2.2 4.4-4.6" stroke="#1670ea" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconLinkedIn() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
      <path d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5ZM.24 8.25h4.5V23H.24V8.25ZM8.02 8.25h4.31v2.02h.06c.6-1.14 2.07-2.34 4.26-2.34 4.56 0 5.4 3 5.4 6.9V23h-4.5v-6.86c0-1.64-.03-3.75-2.28-3.75-2.29 0-2.64 1.79-2.64 3.63V23h-4.5V8.25Z" />
    </svg>
  );
}

export function IconYouTube() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
      <path d="M23 7.2s-.23-1.6-.94-2.32c-.9-.94-1.9-.94-2.36-1C16.4 3.6 12 3.6 12 3.6h-.01s-4.4 0-7.7.28c-.46.06-1.46.06-2.36 1C1.22 5.6 1 7.2 1 7.2S.75 9.06.75 10.93v1.72c0 1.87.25 3.73.25 3.73s.23 1.6.93 2.32c.9.95 2.08.92 2.6 1.02 1.9.18 8.02.27 8.02.27s4.4-.01 7.7-.3c.46-.06 1.46-.06 2.36-1 .7-.72.94-2.32.94-2.32s.25-1.86.25-3.73v-1.72c0-1.87-.25-3.73-.25-3.73ZM9.75 14.98V8.9l6.02 3.05-6.02 3.03Z" />
    </svg>
  );
}

// Rough bounding boxes approximating continents on an 800x400 canvas,
// used to keep only the dots that fall roughly "on land".
const LAND_ZONES: [number, number, number, number][] = [
  [40, 40, 210, 170], // North America
  [150, 190, 270, 330], // South America
  [355, 40, 455, 140], // Europe
  [455, 20, 700, 115], // Russia / CIS
  [360, 145, 470, 320], // Africa
  [460, 140, 520, 195], // Middle East
  [520, 150, 585, 225], // India / South Asia
  [575, 95, 685, 195], // East Asia
  [575, 195, 660, 260], // Southeast Asia
  [640, 275, 745, 355], // Australia
];

function isOnLand(x: number, y: number) {
  return LAND_ZONES.some(([x1, y1, x2, y2]) => x >= x1 && x <= x2 && y >= y1 && y <= y2);
}

export function WorldDotMap({ markers = [] as { x: number; y: number; label: string }[] }) {
  const dots: { x: number; y: number }[] = [];
  const step = 11;
  for (let x = 20; x <= 780; x += step) {
    for (let y = 20; y <= 380; y += step) {
      if (isOnLand(x, y)) dots.push({ x, y });
    }
  }

  return (
    <svg viewBox="0 0 800 400" className="world-map-svg">
      {dots.map((d, i) => (
        <circle key={i} cx={d.x} cy={d.y} r="2.1" fill="#a9c9f2" />
      ))}
      {markers.map((m) => (
        <g key={m.label}>
          <circle cx={m.x} cy={m.y} r="7" fill="#1670ea" opacity="0.18" />
          <circle cx={m.x} cy={m.y} r="3.2" fill="#1461d8" />
        </g>
      ))}
    </svg>
  );
}

export function IconPuzzle() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M4 9h3.2a1.6 1.6 0 1 1 0 3.2V15a1 1 0 0 0 1 1h2.8a1.6 1.6 0 1 1 3.2 0H17a1 1 0 0 0 1-1v-2.8a1.6 1.6 0 1 0 0-3.2V6a1 1 0 0 0-1-1h-2.8a1.6 1.6 0 1 1-3.2 0H8a1 1 0 0 0-1 1v3Z"
        stroke="#1670ea"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
   </svg>
  );
}

export function IconDocument() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M7 3.5h7l3 3V20a.6.6 0 0 1-.6.6H7.6A.6.6 0 0 1 7 20V4a.5.5 0 0 1 0-.5Z" stroke="#1670ea" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M14 3.5V7h3" stroke="#1670ea" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M9.3 12h5.4M9.3 15h5.4M9.3 9h2.4" stroke="#1670ea" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
  );
}

export function IconDiamond() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M4 9.5 8 4h8l4 5.5-8 10.5-8-10.5Z" stroke="#1670ea" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M4 9.5h16M9 4l-2 5.5 5 10.5M15 4l2 5.5-5 10.5" stroke="#1670ea" strokeWidth="1.2" strokeLinejoin="round" />
    </svg>
  );
}

export function IconTarget() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="8.5" stroke="#1670ea" strokeWidth="1.5" />
      <circle cx="12" cy="12" r="4.8" stroke="#1670ea" strokeWidth="1.5" />
      <circle cx="12" cy="12" r="1.4" fill="#1670ea" />
    </svg>
  );
}

export function IconGear() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="3.2" stroke="#1670ea" strokeWidth="1.6" />
      <path
        d="M12 3.5v2M12 18.5v2M20.5 12h-2M5.5 12h-2M17.7 6.3l-1.4 1.4M7.7 16.3l-1.4 1.4M17.7 17.7l-1.4-1.4M7.7 7.7 6.3 6.3"
        stroke="#1670ea"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function IconGlobe() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="8.5" stroke="#1670ea" strokeWidth="1.6" />
      <path d="M3.5 12h17M12 3.5c2.6 2.3 4 5.2 4 8.5s-1.4 6.2-4 8.5c-2.6-2.3-4-5.2-4-8.5s1.4-6.2 4-8.5Z" stroke="#1670ea" strokeWidth="1.4" />
    </svg>
  );
}

export function IconX() {
  return (
    <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.9 2H22l-7.6 8.7L23 22h-6.9l-5.4-6.6L4.5 22H1.3l8.1-9.3L1 2h7.1l4.9 6.1L18.9 2Zm-1.2 18h1.9L7.4 4h-2l12.3 16Z" />
    </svg>
  );
}
export function IconFacebook() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
      <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5.02 3.66 9.18 8.44 9.94v-7.03H7.9v-2.91h2.54V9.85c0-2.51 1.49-3.9 3.77-3.9 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.44 2.91h-2.34V22c4.78-.76 8.44-4.92 8.44-9.94Z" />
    </svg>
  );
}

export function IconInstagram() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
      <rect x="2.5" y="2.5" width="19" height="19" rx="5.5" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="12" cy="12" r="4.6" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="17.4" cy="6.6" r="1.15" fill="currentColor" />
    </svg>
  );
}
export function IconSearch() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle
        cx="10.8"
        cy="10.8"
        r="6.3"
        stroke="#1670ea"
        strokeWidth="1.6"
      />
      <path
        d="m15.5 15.5 5 5"
        stroke="#1670ea"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function IconAlert() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 3.5 21 20H3L12 3.5Z"
        stroke="#1670ea"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path
        d="M12 9v5"
        stroke="#1670ea"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <circle cx="12" cy="17" r="0.9" fill="#1670ea" />
    </svg>
  );
}

export function IconCheck() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle
        cx="12"
        cy="12"
        r="8.5"
        stroke="#1670ea"
        strokeWidth="1.6"
      />
      <path
        d="m8 12.2 2.6 2.6 5.5-5.7"
        stroke="#1670ea"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconPin() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M19 10.2c0 5.1-7 10.3-7 10.3S5 15.3 5 10.2a7 7 0 1 1 14 0Z"
        stroke="#1670ea"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <circle
        cx="12"
        cy="10"
        r="2.4"
        stroke="#1670ea"
        strokeWidth="1.6"
      />
    </svg>
  );
}




export function IconPhone() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M4.5 4.5h3.2l1.4 3.6-1.9 1.7a11.5 11.5 0 0 0 5 5l1.7-1.9 3.6 1.4v3.2c0 .9-.8 1.6-1.7 1.5-3.2-.3-6.3-1.7-8.7-4.1s-3.8-5.5-4.1-8.7c-.1-.9.6-1.7 1.5-1.7Z"
        stroke="#1670ea"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconMail() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="5.5" width="18" height="13" rx="2" stroke="#1670ea" strokeWidth="1.5" />
      <path d="M4 7l8 6 8-6" stroke="#1670ea" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}




export function IconTrophy() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M7 4h10v4a5 5 0 0 1-10 0V4Z" stroke="#1670ea" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M7 5H4v1.5A3.5 3.5 0 0 0 7.5 10M17 5h3v1.5A3.5 3.5 0 0 1 16.5 10" stroke="#1670ea" strokeWidth="1.4" strokeLinecap="round" />
      <path d="M12 13v4M9 20.5h6M9.5 20.5l.7-3.5h3.6l.7 3.5" stroke="#1670ea" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconTrend() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M3.5 16.5 9 10l4 3 7-8" stroke="#1670ea" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15.5 5H20v4.5" stroke="#1670ea" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconCoins() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <ellipse cx="9" cy="7" rx="6" ry="3" stroke="#1670ea" strokeWidth="1.5" />
      <path d="M3 7v4c0 1.7 2.7 3 6 3s6-1.3 6-3V7" stroke="#1670ea" strokeWidth="1.5" />
      <path d="M3 11v4c0 1.7 2.7 3 6 3 1 0 2-.15 2.8-.4" stroke="#1670ea" strokeWidth="1.5" />
      <ellipse cx="16.5" cy="14.5" rx="4.5" ry="2.3" stroke="#1670ea" strokeWidth="1.3" />
      <path d="M12 14.5v3c0 1.27 2 2.3 4.5 2.3s4.5-1.03 4.5-2.3v-3" stroke="#1670ea" strokeWidth="1.3" />
    </svg>
  );
}

export function IconClock() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9" stroke="#1670ea" strokeWidth="1.6" />
      <path d="M12 7v5l3.3 2" stroke="#1670ea" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}



